import Cookies from "js-cookie";
import * as React from "react";
import { observer } from "mobx-react";
import { useContext, useState } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Form, Input, Button, Checkbox, Spin, Select } from "antd";
import { Link, RouteComponentProps } from "react-router-dom";
import { css } from "@emotion/core";
import * as firebase from "firebase/app";
import "firebase/auth";
import { PatternEditor } from "../organisms/PatternEditor";
import { ArrowLink } from "../atoms/ArrowLink";
import { medium } from "../../style/button";
import {
  isReferralOption,
  referralOptions,
} from "../../stores/ContactViewStore";
import { ReferralOptionFormItem } from "../molecules/ReferralOptionFormItem";
import { FixedFooter } from "../atoms/FixedFooter";
import { longLabel } from "../../style/form";
import { Footer } from "../organisms/Footer";
import { apiEndpoint } from "../../util";
import { v4 } from "uuid";
import { track } from "../../services/track";

export const InquiryOrder = observer(({ history }: RouteComponentProps) => {
  const store = useContext(ContactViewStoreContext);

  const [loading, setLoading] = useState(false);

  return (
    <div>
      <h2>おおよそのプランと数量をご記入ください</h2>
      <PatternEditor extended={false} />
      <Form
        labelCol={{ xs: { span: 24 }, sm: { span: 8 } }}
        wrapperCol={{ xs: { span: 24 }, sm: { span: 12 } }}
      >
        <ReferralOptionFormItem />
        <Form.Item label="コメント欄(質問・相談)" css={longLabel}>
          <Input.TextArea
            rows={4}
            value={store.comment}
            onChange={(e) => {
              store.comment = e.target.value;
            }}
          />
        </Form.Item>
      </Form>

      <Footer />

      <FixedFooter>
        <button
          css={medium}
          disabled={loading}
          onClick={() => {
            const currentUser = firebase.auth().currentUser;
            if (currentUser === null) return;

            if (!store.hasAllInfo) {
              alert("プランと数量を入力してください");
              return;
            }
            if (store.referralOption === "選択してください") {
              alert("紹介元を選択してください");
              return;
            }
            if (
              store.referralOption === "プランナー・アドバイザー" &&
              !store.referral
            ) {
              alert("プランナー・アドバイザーの詳細を選択してください");
              return;
            }

            setLoading(true);

            store
              .linkCredential()
              .then((_) => store.persist())
              .then((_) =>
                fetch(apiEndpoint("/postal/orders"), {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    ...store.toRequest("inquiry"),
                    utmCampaign:
                      // サブドメインがあればサブドメインを使用
                      location.host.replace(/\.?postal\.gift$/, "") ||
                      // deprecated: なければlocalStorageの値を使用
                      localStorage.getItem("gift.postal.utm.campaign") ||
                      undefined,
                    // Pixel ID
                    fbp: Cookies.get("_fbp"),
                    // クリックID
                    fbc: Cookies.get("_fbc"),
                    userAgent: navigator.userAgent,
                  }),
                })
              )
              .then((response) => {
                if (response.status >= 400) throw new Error("server error");

                const eventId = v4();

                const request = store.toRequest("inquiry");

                // 詳細マッチング
                // @ts-ignore
                fbq("init", "5851275464976595", {
                  em: request.emailAddress,
                  ph: request.sms,
                });

                // Track conversion event.
                track("CompleteRegistration", request);

                // Push to thank you page.
                history.push("/inquiry/done");
              })
              .catch((e) => {
                console.log("error", e);
                alert("エラーが発生しました");
                setLoading(false);
              });
          }}
        >
          OK
          {loading && <Spin size="small" />}
        </button>
        <ArrowLink to="/inquiry/contact2" direction="left" />
      </FixedFooter>
    </div>
  );
});
